import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DrawOptionInstanceDTO, BetSlipPickedDTO } from '../../../lottomart/model/lottomart-model';

@Component({
  selector: 'app-table-cell-shape',
  templateUrl: './shape-table-cell.component.html',
  styleUrls: ['../shape.component.scss'],
  standalone: false,
})
export class ShapeTableCellComponent extends DataTypeComponent {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  drawOption: DrawOptionInstanceDTO;

  nonSelectedPicked: BetSlipPickedDTO;

  selectedPicked: BetSlipPickedDTO;

  placeholderPicked: BetSlipPickedDTO;

  selectionPlaceholderPicked: BetSlipPickedDTO;

  setRowData(entity: any) {
    if (!entity) {
      return;
    }

    this.drawOption = {
      id: entity.id,
      lottoDrawId: entity.lottoDrawId,
      optionType: entity.optionType,
      primaryDraw: entity.primaryDraw,
      minRange: entity.minRange,
      maxRange: entity.maxRange,
      numberOfSelections: entity.numberOfSelections,
      name: entity.name,
      price: entity.price,
      optional: entity.optional,
      minRangeMultiplier: entity.minRangeMultiplier,
      maxRangeMultiplier: entity.maxRangeMultiplier,
      nonSelectedStrokeColor: entity.nonSelectedStrokeColor,
      nonSelectedFillColor: entity.nonSelectedFillColor,
      selectedStrokeColor: entity.selectedStrokeColor,
      selectedFillColor: entity.selectedFillColor,
      selectedTextColor: entity.selectedTextColor,
      selectionPlaceholderFillColor: entity.selectionPlaceholderFillColor,
      selectionPlaceholderStrokeColor: entity.selectionPlaceholderStrokeColor,
      selectionPlaceholderTextColor: entity.selectionPlaceholderTextColor,
      placeholderFillColor: entity.placeholderFillColor,
      placeholderStrokeColor: entity.placeholderStrokeColor,
      placeholderTextColor: entity.placeholderTextColor,
      shapeType: entity.shapeType,
    } as DrawOptionInstanceDTO;

    this.nonSelectedPicked = {
      id: 1,
      drawOptionId: 1,
      value: 1,
      isNumber: true,
      picked: false,
      inResult: false,
      isJolly: false,
    } as BetSlipPickedDTO;

    this.selectedPicked = {
      id: 1,
      drawOptionId: 1,
      value: 2,
      isNumber: true,
      picked: true,
      inResult: false,
      isJolly: false,
    } as BetSlipPickedDTO;

    this.placeholderPicked = {
      id: 1,
      drawOptionId: 1,
      value: 3,
      isNumber: true,
      picked: false,
      inResult: false,
      isJolly: false,
    } as BetSlipPickedDTO;

    this.selectionPlaceholderPicked = {
      id: 1,
      drawOptionId: 1,
      value: 3,
      isNumber: true,
      picked: true,
      inResult: true,
      isJolly: false,
    } as BetSlipPickedDTO;

    if (entity.optionType === 'JOLLY') {
      this.nonSelectedPicked.isJolly = true;
      this.selectedPicked.isJolly = true;
      this.placeholderPicked.isJolly = true;
      this.selectionPlaceholderPicked.isJolly = true;
    }
  }
}
